import { partnerSupplier } from '@/utils/environment';
import { useMemo } from 'react';
import { usePunchoutParams } from './use-punchout-params';
import { useSmartOrderParams } from './use-smart-order-params';

interface AutoLoginParams {
  businessOrganizationUUID: string;
  cookie: string;
  type: 'PUNCHOUT' | 'SMART_ORDER';
  username: string;
}

export const useAutoLoginParams = (): AutoLoginParams | null => {
  const punchoutParams = usePunchoutParams();
  const smartOrderParams = useSmartOrderParams();

  return useMemo(() => {
    if (punchoutParams) {
      return {
        businessOrganizationUUID: partnerSupplier.businessOrganizationUUID,
        cookie: punchoutParams.cookie,
        type: 'PUNCHOUT',
        username: punchoutParams.username,
      };
    }

    if (smartOrderParams) {
      return {
        businessOrganizationUUID: smartOrderParams.businessOrganizationUUID,
        cookie: smartOrderParams.smartOrderUUID,
        type: 'SMART_ORDER',
        username: smartOrderParams.username,
      };
    }

    return null;
  }, [punchoutParams, smartOrderParams]);
};
